module.exports = __webpack_public_path__ + "img/pandora.f225818b.svg";